import * as resorts from '~/config/ids/idsResorts';

export const MAENNLICHEN = 'maennlichen';
export const EIGERGLETSCHER = 'eigergletscher';
export const KLEINESCHEIDEGG = 'kleinescheidegg';
export const FIRST = 'first';
export const SCHRECKFELD = 'schreckfeld';
export const BUSSALP = 'bussalp';
export const FAULHORN = 'faulhorn';
export const BIRG = 'birg';
export const ALLMENDHUBEL = 'allmendhubel';
export const SCHILTHORN = 'schilthorn';
export const MUERREN = 'muerren';



export const WEATHER_STATIONS = {
    [resorts.WINTER_GW]: [
        MAENNLICHEN,
        EIGERGLETSCHER,
        KLEINESCHEIDEGG,
    ],
    [resorts.WINTER_GF]: [
        FIRST,
        SCHRECKFELD,
        FAULHORN,
        BUSSALP,
    ],
    [resorts.WINTER_MS]: [
        BIRG,
        ALLMENDHUBEL,
    ],
    [resorts.SUMMER_JR]: [

    ],
    [resorts.SUMMER_KS]: [
        MAENNLICHEN,
        EIGERGLETSCHER,
        KLEINESCHEIDEGG,
    ],
    [resorts.SUMMER_GF]: [
        FIRST,
        SCHRECKFELD,
        FAULHORN,
        BUSSALP,
    ],
};

export const WEBCAM_URLS = {
    [MAENNLICHEN]: 'https://backend.roundshot.com/cams/877919abdb23eb59f63908ab8b300f1f/thumbnail',
    [EIGERGLETSCHER]: 'https://backend.roundshot.com/cams/486d6b1c471c581a99233dc3e4cc3ab7/thumbnail',
    [KLEINESCHEIDEGG]: 'https://backend.roundshot.com/cams/527f953c3776c0552355d4a154c2b4e8/thumbnail',
    [SCHRECKFELD]: 'https://backend.roundshot.com/cams/c7f0edeec13d52b6c3cf91485d982548/thumbnail',
    [FIRST]: 'https://www.jungfrau.ch/cfapi/webcam-redirect/v01/image/upload/f_auto,q_auto,h_110/webcams/webcam-grindelwald-first-feratel.jpg',
    [BUSSALP]: 'https://backend.roundshot.com/cams/10/thumbnail',
    [BIRG]: 'https://backend.roundshot.com/cams/d74cd415505930883adc771b527d161b/thumbnail',
    [ALLMENDHUBEL]: 'https://backend.roundshot.com/cams/eba943ecbd06eaa835c4e5c948741534/thumbnail',
    [FAULHORN]: 'https://backend.roundshot.com/cams/7823d0baddb829dad0ccc55bf912afe7/thumbnail',


};

export const WEBCAM_HIGHRES_URLS = {
    [MAENNLICHEN]: 'https://backend.roundshot.com/cams/877919abdb23eb59f63908ab8b300f1f/half',
    [EIGERGLETSCHER]: 'https://backend.roundshot.com/cams/486d6b1c471c581a99233dc3e4cc3ab7/half',
    [KLEINESCHEIDEGG]: 'https://backend.roundshot.com/cams/527f953c3776c0552355d4a154c2b4e8/half',
    [SCHRECKFELD]: 'https://backend.roundshot.com/cams/c7f0edeec13d52b6c3cf91485d982548/half',
    [FIRST]: 'https://www.jungfrau.ch/cfapi/webcam-redirect/v01/image/upload/f_auto,q_auto,h_878,e_pixelate_faces:7/webcams/webcam-grindelwald-first-feratel.jpg',
    [BUSSALP]: 'https://backend.roundshot.com/cams/10/half',
    [BIRG]: 'https://backend.roundshot.com/cams/d74cd415505930883adc771b527d161b/half',
    [ALLMENDHUBEL]: 'https://backend.roundshot.com/cams/eba943ecbd06eaa835c4e5c948741534/half',
    [FAULHORN]: 'https://backend.roundshot.com/cams/7823d0baddb829dad0ccc55bf912afe7/half',
};



// Lower number = faster
const speedMultiplier = 1.3;

export const WEBCAM_SETTINGS = {
    [MAENNLICHEN]: {
        animationStartPercent: 0 - 0,
        animationEndPercent: -33.3333 - 0,
        animationDuration: 30 * speedMultiplier,
    },
    [EIGERGLETSCHER]: {
        animationStartPercent: 0 - 20,
        animationEndPercent: -33.3333 - 20,
        animationDuration: 30 * speedMultiplier,
    },
    [KLEINESCHEIDEGG]: {
        animationStartPercent: 0 - 4,
        animationEndPercent: -33.3333 - 4,
        animationDuration: 30 * speedMultiplier,
    },
    [FIRST]: {
        animationStartPercent: 0 - 0,
        animationEndPercent: -33.3333 - 0,
        animationDuration: 41 * speedMultiplier,
    },
    [SCHRECKFELD]: {
        animationStartPercent: 0 - 25,
        animationEndPercent: -33.3333 - 25,
        animationDuration: 41 * speedMultiplier,
    },
    [FAULHORN]: {
        animationStartPercent: 0 - 0,
        animationEndPercent: -33.3333 - 0,
        animationDuration: 41 * speedMultiplier,
    },
    [BUSSALP]: {
        animationStartPercent: 0 - 25,
        animationEndPercent: -33.3333 - 25,
        animationDuration: 41 * speedMultiplier,
    },
    [BIRG]: {
        animationStartPercent: 0 - 25,
        animationEndPercent: -33.3333 - 25,
        animationDuration: 41 * speedMultiplier,
    },
    [ALLMENDHUBEL]: {
        animationStartPercent: 0 - 25,
        animationEndPercent: -33.3333 - 25,
        animationDuration: 41 * speedMultiplier,
    },
};
